import React from 'react';

import { BackgroundImageContainer as AchievableBackgroundImageContainer } from '@achievable-me/ux';

const BackgroundImageContainer = ({
  children,
  className,
  fixed,
  hideBackground,
  hideBackgroundMobile,
  reverse,
  size,
  theme,
  type,
}) => {
  return (
    <AchievableBackgroundImageContainer
      className={className}
      fixed={fixed}
      hideBackground={hideBackground}
      hideBackgroundMobile={hideBackgroundMobile}
      reverse={reverse}
      size={size}
      theme={theme}
      type={type}
    >
      {children}
    </AchievableBackgroundImageContainer>
  );
};

export default BackgroundImageContainer;
